import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';

class CheckBoxField extends Component {
    render() {
        const { isChecked, onChangeHandler, name, id, text = null } = this.props;
        return <label className="checkbox checkbox-outline checkbox-outline-2x checkbox-primary" htmlFor={id}>
        <input type="checkbox" id={id} className="checkbox form-check-input" name={name} checked={isChecked} onChange={onChangeHandler} />
         <span>{ text ? text : text!=0 ? 'Manually approve posts before making them public?' : <></> }</span>
        </label>
    }
}

export default CheckBoxField;